import { axios } from '@/utils/request'
// 获取完成进度
export function getUserSchedule(params) {
  return axios({
    url: '/distribution/userSchedule?is_all=1',
    method: 'GET',
    params
  })
}

// 获取热卖产品
export function getHotProducts() {
  const params = {
    per_page: 6,
    product_tag: 'hot'
  }
  return axios({
    url: '/frontend/basicProduct',
    method: 'GET',
    params
  })
}

// 获取任务进度
export function getTaskProcess(params) {
  return axios({
    url: '/distribution/userSchedule',
    method: 'GET',
    params
  })
}
